import { toast } from "react-toastify";

import BranchClient from "../../../api/branch";
import WarehouseClient from "../../../api/warehouse";

toast.configure();
export const branches = {
  state: {
    branches: [],
    filterState:[],
    filteredBranches: [],
    filteredBranchString: '',
    selectedOC: "",
    filterPeriod: 3,
    branchRegions: [],
    filterRegionState: [],
    filteredBranchRegions: [],
    filteredBranchRegionString: ''
  },
  reducers: {
    setFilteredRegions(state, payload) {
         return {
          ...state,
          filterRegionState: payload,
      };
    },
    setFiltered(state, payload) {

         return {
          ...state,
          filterState: payload,
      };
    },
    setFilteredBranches(state, payload) {
      localStorage.setItem('selectedBranches', JSON.stringify(payload));
         return {
        ...state,
        filteredBranches: payload,
        filteredBranchString: payload ? payload.map((i) => i && i.value).join() : ''
      };
    },
    setFilteredBranchRegions(state, payload) {
      localStorage.setItem('selectedRegions', JSON.stringify(payload));

         return {
        ...state,
        filteredBranchRegions: payload,
        filteredBranchRegionString: payload ? payload.map((i) => i && i.value).join() : ''
      };
    },
    setBranches(state, payload) {
      return {
        ...state,
        branches: payload,
      };
    },
    setBranchRegions(state, payload) {
      return {
        ...state,
        branchRegions: payload,
      };
    },
    setPeriod(state, payload) {
      localStorage.setItem('selectedPeriod', JSON.stringify(payload));
      return {
        ...state,
        filterPeriod: payload,
      };
    },
    setOC(state, payload) {
      return {
        ...state,
        selectedOC: payload,
      };
    },
    clearStore() {
      return {};
    },
  },
  effects: (dispatch) => ({
    async setFilteredAsync(payload, rootState) {
          if (payload && payload.length >1) {
            await this.setFiltered(payload);
          } else {
            const selectedBranches = await localStorage.getItem('selectedBranches');
            if (selectedBranches) {
              this.setFiltered(JSON.parse(selectedBranches));
              dispatch.notifications.getNotificationsAsync(JSON.parse(selectedBranches))
             this.setFilteredBranches(JSON.parse(selectedBranches));
            }
          }
    },
    async setFilteredRegionsAsync(payload, rootState) {
          if (payload && payload.length >1) {
            await this.setFilteredRegions(payload);
          } else {
            const selectedRegions = await localStorage.getItem('selectedRegions');
            if (selectedRegions) {
              this.setFilteredRegions(JSON.parse(selectedRegions));
              dispatch.notifications.getNotificationsByRegionAsync(JSON.parse(selectedRegions))
             this.setFilteredBranchRegions(JSON.parse(selectedRegions));
            }
          }
    },
    async setPeriodAsync(payload, rootState) {
      if(payload){
          this.setPeriod(payload)
        }else{
            const selectedPeriod = await localStorage.getItem('selectedPeriod');
              if (selectedPeriod) {
                this.setPeriod(JSON.parse(selectedPeriod));
              }
          }
        },
    setOCAsync(payload, rootState) {
      this.setOC(payload);
    },

    async setBranchesAsync(payload, rootState) {
      try {
        if (payload.userId && payload.userGroup === 'warehouse') {
          const { userId } = payload;

          const res = await WarehouseClient.getBranchByWarehouseUser(userId);
          const { data } = res;

          this.setBranches(data);
        } else {
          const res = await BranchClient.getAllByIdRole();
          const { data } = res;

          this.setBranches(data);
        }
      } catch (error) {
        await  toast.error('Algo deu errado :( !', {
          position: "top-right",
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          });
      }
    },
    async setTransportersBranchesAsync(payload, rootState) {
      try {
        const transporterIds = payload.replaceAll(",", "/");
        const res = await BranchClient.getAllByTransporters(transporterIds);
        const { data } = res;

        this.setBranches(data);
      } catch (error) {
        await  toast.error('Algo deu errado :( !', {
          position: "top-right",
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          });
      }
    },
    async setBranchRegionsAsync(payload, rootState) {
      try {
        const res = await BranchClient.getBranchRegions();
        const { data } = res;

        this.setBranchRegions(data);
      } catch (error) {
        await  toast.error('Algo deu errado :( !', {
          position: "top-right",
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          });
      }
    },
  }),
};
